/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import InputWrapper from "../../components/controls/InputWrapper";
import SelectWrapper from "../../components/controls/SelectWrapper";
import CheckboxWrapper from "../../components/controls/CheckboxWrapper";
import InputHint from "../../components/utils/InputHint";
import { IonButton, IonCol, IonContent, IonGrid, IonIcon, IonItem, IonLabel, IonPage, IonRadio, IonRadioGroup, IonRow, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonText, useIonLoading, useIonToast } from "@ionic/react";
import HttpClient from "../../helpers/HttpClient";
import logo from "../../assets/images/logo.svg";
import { add, checkmarkCircleOutline, trashOutline } from "ionicons/icons";
import { useDebounce } from "usehooks-ts";
import { useTaxNumberQuery } from "../../hooks/useTaxNumberQuery";
import InputError from "../../components/utils/InputError";
import PhoneWrapper from "../../components/controls/PhoneWrapper";
import { capitalizeFirstLetter } from "../../helpers/GlobalHelpers";
import "./ElectronicDataRequestPage.scss";

const ElectronicDataRequestPage: React.FC = () => {
  const { uid }: { uid: string } = useParams();
  const [presentLoading, dismissLoading] = useIonLoading();
  const [presentToast] = useIonToast();
  const { fetchTaxNumberDetails } = useTaxNumberQuery();
  const {
    control,
    formState: { errors },
    watch,
    trigger,
    getValues,
    setValue,
    setError,
  } = useForm({
    defaultValues: {
      CardName: "",
      U_PartnerJogcim: "",
      U_SzamlaTipus: "",
      E_Mail: "",
      GroupNum: "",
      U_Kutya: "",
      Kepviselo_LastName: "",
      Kepviselo_FirstName: "",
      VatIdUnCmp: "",
      Shipping_ZipCode: "",
      Shipping_City: "",
      Shipping_Street: "",
      Shipping_State: "",
      Shipping_StreetNo: "",
      Billing_ZipCode: "",
      Billing_City: "",
      Billing_Street: "",
      Billing_State: "",
      Billing_StreetNo: "",
      Postal_ZipCode: "",
      Postal_City: "",
      Postal_Street: "",
      Postal_State: "",
      Postal_StreetNo: "",
      Phone1: "",
      U_AnyjaNeve: "",
      U_SzulHely: "",
      U_SzulIdo: "",
      U_ObjJelleg: "",
      U_LemondoJelszo: "",
      "Ertesitendok-0-U_Name": "",
      "Ertesitendok-0-U_Telefon": "",
      "Ertesitendok-0-U_E_mail": "",
      "Ertesitendok-0-U_TechnikaiSMS": true,
      "Ertesitendok-1-U_Name": "",
      "Ertesitendok-1-U_Telefon": "",
      "Ertesitendok-1-U_E_mail": "",
      "Ertesitendok-1-U_TechnikaiSMS": false,
      "Ertesitendok-2-U_Name": "",
      "Ertesitendok-2-U_Telefon": "",
      "Ertesitendok-2-U_E_mail": "",
      "Ertesitendok-2-U_TechnikaiSMS": false,
      U_TulNeve: "",
      U_TulTelefon: "",
      U_myPatentAktivalas: false,
      U_Adatkezeles: false,
      CPH_CustomerVatData: "customerTaxNumber",
    },
  });
  const [edr, setEdr] = useState<any>(undefined);
  const [ceges, setCeges] = useState<boolean>(false);
  const [ertesitendokCount, setErtesitendokCount] = useState<number>(1);
  const [sent, setSent] = useState<boolean>(false);
  const [selectableAddresses, setSelectableAddresses] = useState<any>([]);
  const [validVatNumber, setValidVatNumber] = useState<boolean>(false);

  const watchCPH_CustomerVatData = watch("CPH_CustomerVatData");
  const watchVatIdUnCmp = watch("VatIdUnCmp");
  const debouncedWatchVatIdUnCmp = useDebounce<string>(watchVatIdUnCmp, 500);
  const [selectedTechnikaiSmsIndex, setSelectedTechnikaiSmsIndex] = useState<number | null>(null);
  const Kepviselo_LastName_Ref = useRef<HTMLIonInputElement>();

  const handleFetchTaxNumberDetails = async () => {
    const result = await fetchTaxNumberDetails({
      CPH_CustomerVatData: watchCPH_CustomerVatData,
      tax_number: watchCPH_CustomerVatData === "customerTaxNumber" && debouncedWatchVatIdUnCmp.length > 8 ? debouncedWatchVatIdUnCmp.substring(0, 8) : debouncedWatchVatIdUnCmp,
    });
    if (!result) {
      setValidVatNumber(false);
      presentToast(`Nincs találat erre az adószámra: ${debouncedWatchVatIdUnCmp}`, 8000);
      return;
    }
    setValidVatNumber(true);
    setValue("CardName", capitalizeFirstLetter(result.name));

    if (Kepviselo_LastName_Ref?.current) {
      Kepviselo_LastName_Ref.current.setFocus();
    }

    let _addresses = [];
    if (Array.isArray(result.addresses)) {
      _addresses = result.addresses;
    } else {
      _addresses = [result.addresses];
    }

    if (_addresses.length > 0) {
      setSelectableAddresses(_addresses);
    }

    let a = null;
    if (_addresses.length === 1) {
      a = result.addresses[0];
    }

    /*
    if (!Array.isArray(result.addresses) && "taxpayerAddress" in result.addresses) {
      a = result.addresses;
    }
    */

    if (a) {
      setValue("Billing_City", a.taxpayerAddress.city);
      setValue("Billing_Street", a.taxpayerAddress.streetName);
      setValue("Billing_StreetNo", a.taxpayerAddress.number);
      setValue("Billing_ZipCode", a.taxpayerAddress.postalCode);
      for (const kozterulet_tipus of kozterulet_tipusok) {
        if (kozterulet_tipus.label.toLowerCase() == a.taxpayerAddress.publicPlaceCategory.toLowerCase()) {
          setValue("Billing_State", kozterulet_tipus.id);
          break;
        }
      }
    }
  };

  useEffect(() => {
    let regex = new RegExp(/^(\d{7})(\d)\-([1-5])\-(0[2-9]|[13][0-9]|2[02-9]|4[0-4]|51)$/);
    if (watchCPH_CustomerVatData === "customerTaxNumber" && !regex.test(watchVatIdUnCmp)) {
      return;
    }
    if (debouncedWatchVatIdUnCmp !== "") {
      handleFetchTaxNumberDetails();
    }
  }, [debouncedWatchVatIdUnCmp, watchCPH_CustomerVatData]);

  useEffect(() => {
    if (selectedTechnikaiSmsIndex && ertesitendokCount <= selectedTechnikaiSmsIndex) {
      setSelectedTechnikaiSmsIndex(null);
    }
  }, [ertesitendokCount]);

  useEffect(() => {
    if (edr) {
      setCeges(edr ? edr.base_data_customer.CmpPrivate === "C" : false);
    }
  }, [edr]);

  const handleSubmit = async () => {
    if (!(await trigger())) {
      return;
    }
    const values = getValues();

    // Magánszemély
    const Ertesitendok = [];
    for (let i = 0; i < ertesitendokCount; i++) {
      Ertesitendok.push({
        // @ts-ignore
        U_Name: values[`Ertesitendok-${i}-U_Name`] ?? "",
        // @ts-ignore
        U_Telefon: values[`Ertesitendok-${i}-U_Telefon`] ?? "",
        // @ts-ignore
        U_E_mail: values[`Ertesitendok-${i}-U_E_mail`] ?? "",
        // @ts-ignore
        U_TechnikaiSMS: selectedTechnikaiSmsIndex === i ? "Y" : "N",
      });
    }
    if (selectedTechnikaiSmsIndex === null) {
      for (let i = 0; i < ertesitendokCount; i++) {
        // @ts-ignore
        setError(`Ertesitendok-${i}-U_TechnikaiSMS`, {
          type: "custom",
          message: "1 technikai smst kell kiválasztani.",
        });
      }
      return;
    }

    if (values.U_myPatentAktivalas === false) {
      setError(`U_myPatentAktivalas`, {
        type: "custom",
        message: "Kötelező mező.",
      });
      return;
    }

    if (values.U_Adatkezeles === false) {
      setError(`U_Adatkezeles`, {
        type: "custom",
        message: "Kötelező mező.",
      });
      return;
    }

    let tulajdonos = {
      U_TulNeve: values.U_TulNeve ?? "",
      U_TulTelefon: values.U_TulTelefon ?? "",
    };
    if (values.U_PartnerJogcim === "TUL") {
      tulajdonos = {
        U_TulNeve: values.CardName ?? "",
        U_TulTelefon: values.Phone1 ?? "",
      };
    }

    const json = {
      CardName: values.CardName,
      Addresses: {
        Shipping: {
          ZipCode: values.Shipping_ZipCode,
          City: values.Shipping_City,
          Street: values.Shipping_Street,
          State: values.Shipping_State,
          StreetNo: values.Shipping_StreetNo,
        },
        Billing: {
          ZipCode: values.Billing_ZipCode,
          City: values.Billing_City,
          Street: values.Billing_Street,
          State: values.Billing_State,
          StreetNo: values.Billing_StreetNo,
        },
        Postal: {
          ZipCode: values.Postal_ZipCode,
          City: values.Postal_City,
          Street: values.Postal_Street,
          State: values.Postal_State,
          StreetNo: values.Postal_StreetNo,
        },
      },
      Phone1: values.Phone1 ?? "",
      U_AnyjaNeve: values.U_AnyjaNeve ?? "",
      U_SzulHely: values.U_SzulHely ?? "",
      U_SzulIdo: values.U_SzulIdo ?? "",
      U_ObjJelleg: values.U_ObjJelleg ?? "",
      U_PartnerJogcim: values.U_PartnerJogcim ?? "",
      // speckó
      U_TulNeve: tulajdonos.U_TulNeve ?? "",
      U_TulTelefon: tulajdonos.U_TulTelefon ?? "",
      // speckó
      U_SzamlaTipus: values.U_SzamlaTipus ?? "",
      E_Mail: values.E_Mail ?? "",
      GroupNum: values.GroupNum ?? "",
      Ertesitendok: Ertesitendok,
      U_Kutya: values.U_Kutya ?? "",
      U_LemondoJelszo: values.U_LemondoJelszo ?? "",
      U_myPatentAktivalas: values.U_myPatentAktivalas ?? "",
      U_Adatkezeles: values.U_Adatkezeles ?? "",
      CmpPrivate: "I",
    };

    const json_ceg = {
      CardName: values.CardName ?? "",
      Kepviselo: {
        FirstName: values.Kepviselo_FirstName ?? "",
        LastName: values.Kepviselo_LastName ?? "",
      },
      VatIdUnCmp: values.VatIdUnCmp ?? "",
      Addresses: {
        Shipping: {
          ZipCode: values.Shipping_ZipCode,
          City: values.Shipping_City,
          Street: values.Shipping_Street,
          State: values.Shipping_State,
          StreetNo: values.Shipping_StreetNo,
        },
        Billing: {
          ZipCode: values.Billing_ZipCode,
          City: values.Billing_City,
          Street: values.Billing_Street,
          State: values.Billing_State,
          StreetNo: values.Billing_StreetNo,
        },
        Postal: {
          ZipCode: values.Postal_ZipCode,
          City: values.Postal_City,
          Street: values.Postal_Street,
          State: values.Postal_State,
          StreetNo: values.Postal_StreetNo,
        },
      },
      Phone1: values.Phone1 ?? "",
      U_ObjJelleg: values.U_ObjJelleg ?? "",
      U_PartnerJogcim: values.U_PartnerJogcim ?? "",
      // speckó
      U_TulNeve: tulajdonos.U_TulNeve ?? "",
      U_TulTelefon: tulajdonos.U_TulTelefon ?? "",
      // speckó
      U_SzamlaTipus: values.U_SzamlaTipus ?? "",
      E_Mail: values.E_Mail ?? "",
      GroupNum: values.GroupNum ?? "",
      Ertesitendok: Ertesitendok,
      U_Kutya: values.U_Kutya ?? "",
      U_LemondoJelszo: values.U_LemondoJelszo ?? "",
      U_myPatentAktivalas: values.U_myPatentAktivalas ?? "",
      U_Adatkezeles: values.U_Adatkezeles ?? "",
      CmpPrivate: "C",
    };

    await presentLoading("Kérjük várjon...");
    HttpClient({
      url: "/v2/electronic-data-request",
      method: "post",
      data: {
        UID: uid,
        form_data: ceges ? json_ceg : json,
      },
    })
      .then(() => {
        setSent(true);
      })
      .finally(() => {
        dismissLoading();
      });
  };

  const handleFetchEdr = async (uid: string) => {
    await presentLoading("Kérjük várjon...");
    HttpClient({
      url: "/v2/electronic-data-request",
      method: "get",
      params: {
        UID: uid,
      },
    })
      .then((res: any) => {
        if (res.data.data.submitted_at === null) {
          setEdr(res.data.data);

          const c = res.data.data.base_data_customer;
          // setValue("Phone1", c.Phone1); // Ez nem működött
          setValue("U_SzamlaTipus", c.U_SzamlaTipus);
          setValue("GroupNum", c.GroupNum);
        } else {
          setSent(true);
        }
      })
      .finally(() => {
        dismissLoading();
      });
  };

  useEffect(() => {
    handleFetchEdr(uid);
  }, [uid]);

  const handleCegesModositas = (tabKey: string) => {
    setCeges(tabKey === "ceges" ? true : false);
    if (tabKey === "nemceges") {
      setValue("CPH_CustomerVatData", "customerTaxNumber");
      setValue("VatIdUnCmp", "");
      setValue("Kepviselo_LastName", "");
      setValue("Kepviselo_FirstName", "");
      setValue("U_AnyjaNeve", "");
      setValue("U_SzulHely", "");
      setValue("U_SzulIdo", "");
    }
  };

  const billingAddressCopyToShippingAddress = () => {
    const values = getValues();
    setValue("Shipping_City", values?.Billing_City ?? "");
    setValue("Shipping_Street", values?.Billing_Street ?? "");
    setValue("Shipping_StreetNo", values?.Billing_StreetNo ?? "");
    setValue("Shipping_ZipCode", values?.Billing_ZipCode ?? "");
    setValue("Shipping_State", values?.Billing_State ?? "");
  };

  const billingAddressCopyToPostalAddress = () => {
    const values = getValues();
    setValue("Postal_City", values?.Billing_City ?? "");
    setValue("Postal_Street", values?.Billing_Street ?? "");
    setValue("Postal_StreetNo", values?.Billing_StreetNo ?? "");
    setValue("Postal_ZipCode", values?.Billing_ZipCode ?? "");
    setValue("Postal_State", values?.Billing_State ?? "");
  };

  return (
    <IonPage className="electronic-data-request-page">
      <IonContent style={{ padding: "10px" }}>
        <IonGrid fixed>
          <div style={{ padding: "10px 20px" }}>
            <img src={logo} alt="myPatent Logo" className="desktopLogo" />
            <h1 className="pageTitle">Elektronikus adatbekérő</h1>
          </div>
          <div className="tab-container">
            <IonSegment value={ceges ? "ceges" : "nemceges"} onIonChange={(ev) => handleCegesModositas(ev.detail.value)}>
              <IonSegmentButton value="ceges">
                <IonLabel>Cég</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="nemceges">
                <IonLabel>Magánszemély</IonLabel>
              </IonSegmentButton>
            </IonSegment>
          </div>
        </IonGrid>
        {sent ? (
          <div>
            <IonText color="success">
              <h1 className="ion-text-center alertIcon">
                <IonIcon icon={checkmarkCircleOutline} />
              </h1>
              <h2 className="ion-text-center alertText">Sikeres adatbeküldés</h2>
            </IonText>
          </div>
        ) : (
          <>
            {edr === undefined ? (
              <IonGrid fixed>
                <IonRow>
                  <IonCol>
                    <i>Kérjük várjon...</i>
                  </IonCol>
                </IonRow>
              </IonGrid>
            ) : (
              <>
                <IonGrid className="has-bg" fixed>
                  <IonRow>
                    <IonCol>
                      <h4
                        style={{
                          color: "var(--ion-color-primary)",
                        }}
                      >
                        <b>Alapadatok</b>
                      </h4>
                    </IonCol>
                  </IonRow>
                  {ceges ? (
                    <>
                      <IonRow>
                        <IonCol size="12" sizeSm="6">
                          <SelectWrapper
                            name="CPH_CustomerVatData"
                            label="Adószám típusa"
                            controlData={{
                              control: control,
                              rules: {
                                required: {
                                  value: true,
                                  message: "Kötelező mező",
                                },
                              },
                            }}
                            selectData={{}}
                            options={[
                              {
                                key: "customerTaxNumber",
                                name: "Belföldi adószám",
                              },
                              {
                                key: "communityVatNumber",
                                name: "EU adószám",
                              },
                              {
                                key: "thirdStateTaxId",
                                name: "Harmadik országbeli adószám",
                              },
                            ]}
                            error={errors.CPH_CustomerVatData}
                          />
                        </IonCol>
                        <IonCol size="12" sizeSm="6">
                          <InputWrapper
                            name="VatIdUnCmp"
                            label="Adószám"
                            controlData={{
                              control: control,
                              rules: {
                                required: {
                                  value: true,
                                  message: "Kötelező mező",
                                },
                                pattern:
                                  watchCPH_CustomerVatData === "customerTaxNumber"
                                    ? {
                                        value: /^(\d{7})(\d)\-([1-5])\-(0[2-9]|[13][0-9]|2[02-9]|4[0-4]|51)$/,
                                        message: "Hibás adószám formátum",
                                      }
                                    : undefined,
                              },
                            }}
                            inputData={{
                              type: "text",
                              pattern: "text",
                            }}
                            error={errors.VatIdUnCmp}
                          />
                        </IonCol>
                      </IonRow>
                    </>
                  ) : null}

                  <IonRow>
                    <IonCol size="12">
                      <InputWrapper
                        name="CardName"
                        label="Szerződő neve"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                        }}
                        error={errors.CardName}
                      />
                    </IonCol>
                  </IonRow>

                  {ceges ? (
                    <IonRow>
                      <IonCol size="12" sizeSm="6">
                        <InputWrapper
                          name="Kepviselo_LastName"
                          label="Képviselő vezetékneve"
                          controlData={{
                            control: control,
                            rules: {
                              required: {
                                value: true,
                                message: "Kötelező mező",
                              },
                            },
                          }}
                          inputData={{
                            type: "text",
                            pattern: "text",
                            ref: Kepviselo_LastName_Ref,
                          }}
                          error={errors.Kepviselo_LastName}
                        />
                      </IonCol>
                      <IonCol size="12" sizeSm="6">
                        <InputWrapper
                          name="Kepviselo_FirstName"
                          label="Képviselő keresztneve"
                          controlData={{
                            control: control,
                            rules: {
                              required: {
                                value: true,
                                message: "Kötelező mező",
                              },
                            },
                          }}
                          inputData={{
                            type: "text",
                            pattern: "text",
                          }}
                          error={errors.Kepviselo_FirstName}
                        />
                      </IonCol>
                    </IonRow>
                  ) : null}
                </IonGrid>

                <IonGrid className="has-bg" fixed>
                  <IonRow>
                    <IonCol>
                      <h4
                        style={{
                          color: "var(--ion-color-primary)",
                        }}
                      >
                        <b>Számlázási cím</b>
                      </h4>
                    </IonCol>
                  </IonRow>

                  {selectableAddresses.length > 0 ? (
                    <IonRow>
                      <IonCol size="12">
                        <div className="ion-stack vertical">
                          <IonSelect
                            interfaceOptions={{
                              message: "Válasszon a címek közül",
                            }}
                            onIonChange={(event) => {
                              const a = selectableAddresses[event.detail.value];
                              setValue("Billing_City", capitalizeFirstLetter(a.taxpayerAddress.city));
                              setValue("Billing_Street", capitalizeFirstLetter(a.taxpayerAddress.streetName));
                              setValue("Billing_StreetNo", capitalizeFirstLetter(a.taxpayerAddress.number ?? ""));
                              setValue("Billing_ZipCode", capitalizeFirstLetter(a.taxpayerAddress.postalCode));
                              for (const kozterulet_tipus of kozterulet_tipusok) {
                                if (kozterulet_tipus.label.toLowerCase() == a.taxpayerAddress.publicPlaceCategory.toLowerCase()) {
                                  setValue("Billing_State", kozterulet_tipus.id);
                                  break;
                                }
                              }
                            }}
                            value=""
                            okText="Rendben"
                            cancelText="Mégse"
                            placeholder="Válasszon a címek közül..."
                          >
                            {selectableAddresses.map((a: any, index: number) => (
                              <IonSelectOption key={`valami-${index}`} value={index}>
                                {`${capitalizeFirstLetter(a.taxpayerAddress.postalCode)} ${capitalizeFirstLetter(a.taxpayerAddress.city)} ${capitalizeFirstLetter(a.taxpayerAddress.streetName)} ${capitalizeFirstLetter(
                                  a.taxpayerAddress.publicPlaceCategory
                                )} ${capitalizeFirstLetter(a.taxpayerAddress.number ?? "")}`}
                              </IonSelectOption>
                            ))}
                          </IonSelect>
                        </div>
                      </IonCol>
                    </IonRow>
                  ) : null}

                  <IonRow>
                    <IonCol size="12" sizeSm="1">
                      <InputWrapper
                        name="Billing_ZipCode"
                        label="IRSZ"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                          readonly: ceges && watchCPH_CustomerVatData === "customerTaxNumber" && !validVatNumber,
                          disabled: ceges && watchCPH_CustomerVatData === "customerTaxNumber" && !validVatNumber,
                        }}
                        error={errors.Billing_ZipCode}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="3">
                      <InputWrapper
                        name="Billing_City"
                        label="Település"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                          readonly: ceges && watchCPH_CustomerVatData === "customerTaxNumber" && !validVatNumber,
                          disabled: ceges && watchCPH_CustomerVatData === "customerTaxNumber" && !validVatNumber,
                        }}
                        error={errors.Billing_City}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="4">
                      <InputWrapper
                        name="Billing_Street"
                        label="Közterület neve"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                          readonly: ceges && watchCPH_CustomerVatData === "customerTaxNumber" && !validVatNumber,
                          disabled: ceges && watchCPH_CustomerVatData === "customerTaxNumber" && !validVatNumber,
                        }}
                        error={errors.Billing_Street}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="2">
                      <SelectWrapper
                        name="Billing_State"
                        label="Közterület jellege"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        selectData={{
                          readonly: ceges && watchCPH_CustomerVatData === "customerTaxNumber" && !validVatNumber,
                          disabled: ceges && watchCPH_CustomerVatData === "customerTaxNumber" && !validVatNumber,
                        }}
                        options={kozterulet_tipusok.map((kozterulet_tipus: any) => ({
                          key: kozterulet_tipus.id,
                          name: kozterulet_tipus.label,
                        }))}
                        error={errors.Billing_State}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="2">
                      <InputWrapper
                        name="Billing_StreetNo"
                        label="Házszám"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                          readonly: ceges && watchCPH_CustomerVatData === "customerTaxNumber" && !validVatNumber,
                          disabled: ceges && watchCPH_CustomerVatData === "customerTaxNumber" && !validVatNumber,
                        }}
                        error={errors.Billing_StreetNo}
                      />
                    </IonCol>
                  </IonRow>

                  <IonRow>
                    <IonCol size="6">
                      <h4
                        style={{
                          color: "var(--ion-color-primary)",
                        }}
                      >
                        <b>Riasztási objektum címe</b>
                      </h4>
                    </IonCol>
                    {!ceges ? (
                      <IonCol size="6">
                        <div className="ion-text-right">
                          <IonButton color="warning" size="small" onClick={billingAddressCopyToShippingAddress}>
                            Számlázási cím másolása
                          </IonButton>
                        </div>
                      </IonCol>
                    ) : null}
                  </IonRow>

                  {selectableAddresses.length > 0 ? (
                    <IonRow>
                      <IonCol size="12">
                        <div className="ion-stack vertical">
                          <IonSelect
                            interfaceOptions={{
                              message: "Válasszon a címek közül",
                            }}
                            onIonChange={(event) => {
                              const a = selectableAddresses[event.detail.value];
                              setValue("Shipping_City", capitalizeFirstLetter(a.taxpayerAddress.city));
                              setValue("Shipping_Street", capitalizeFirstLetter(a.taxpayerAddress.streetName));
                              setValue("Shipping_StreetNo", capitalizeFirstLetter(a.taxpayerAddress.number ?? ""));
                              setValue("Shipping_ZipCode", capitalizeFirstLetter(a.taxpayerAddress.postalCode));
                              for (const kozterulet_tipus of kozterulet_tipusok) {
                                if (kozterulet_tipus.label.toLowerCase() == a.taxpayerAddress.publicPlaceCategory.toLowerCase()) {
                                  setValue("Shipping_State", kozterulet_tipus.id);
                                  break;
                                }
                              }
                            }}
                            value=""
                            okText="Rendben"
                            cancelText="Mégse"
                            placeholder="Válasszon a címek közül..."
                          >
                            {selectableAddresses.map((a: any, index: number) => (
                              <IonSelectOption key={`valami-${index}`} value={index}>
                                {`${capitalizeFirstLetter(a.taxpayerAddress.postalCode)} ${capitalizeFirstLetter(a.taxpayerAddress.city)} ${capitalizeFirstLetter(a.taxpayerAddress.streetName)} ${capitalizeFirstLetter(
                                  a.taxpayerAddress.publicPlaceCategory
                                )} ${capitalizeFirstLetter(a.taxpayerAddress.number ?? "")}`}
                              </IonSelectOption>
                            ))}
                          </IonSelect>
                        </div>
                      </IonCol>
                    </IonRow>
                  ) : null}

                  <IonRow>
                    <IonCol size="12" sizeSm="1">
                      <InputWrapper
                        name="Shipping_ZipCode"
                        label="IRSZ"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                        }}
                        error={errors.Shipping_ZipCode}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="3">
                      <InputWrapper
                        name="Shipping_City"
                        label="Település"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                        }}
                        error={errors.Shipping_City}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="4">
                      <InputWrapper
                        name="Shipping_Street"
                        label="Közterület neve"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                        }}
                        error={errors.Shipping_Street}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="2">
                      <SelectWrapper
                        name="Shipping_State"
                        label="Közterület jellege"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        selectData={{}}
                        options={kozterulet_tipusok.map((kozterulet_tipus: any) => ({
                          key: kozterulet_tipus.id,
                          name: kozterulet_tipus.label,
                        }))}
                        error={errors.Shipping_State}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="2">
                      <InputWrapper
                        name="Shipping_StreetNo"
                        label="Házszám"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                        }}
                        error={errors.Shipping_StreetNo}
                      />
                    </IonCol>
                  </IonRow>

                  <IonRow>
                    <IonCol>
                      <h4
                        style={{
                          color: "var(--ion-color-primary)",
                        }}
                      >
                        <b>Levelezési cím</b>
                      </h4>
                    </IonCol>
                  </IonRow>

                  {selectableAddresses.length > 0 ? (
                    <IonRow>
                      <IonCol size="12">
                        <div className="ion-stack vertical">
                          <IonSelect
                            interfaceOptions={{
                              message: "Válasszon a címek közül",
                            }}
                            onIonChange={(event) => {
                              const a = selectableAddresses[event.detail.value];
                              setValue("Postal_City", capitalizeFirstLetter(a.taxpayerAddress.city));
                              setValue("Postal_Street", capitalizeFirstLetter(a.taxpayerAddress.streetName));
                              setValue("Postal_StreetNo", capitalizeFirstLetter(a.taxpayerAddress.number ?? ""));
                              setValue("Postal_ZipCode", capitalizeFirstLetter(a.taxpayerAddress.postalCode));
                              for (const kozterulet_tipus of kozterulet_tipusok) {
                                if (kozterulet_tipus.label.toLowerCase() == a.taxpayerAddress.publicPlaceCategory.toLowerCase()) {
                                  setValue("Postal_State", kozterulet_tipus.id);
                                  break;
                                }
                              }
                            }}
                            value=""
                            okText="Rendben"
                            cancelText="Mégse"
                            placeholder="Válasszon a címek közül..."
                          >
                            {selectableAddresses.map((a: any, index: number) => (
                              <IonSelectOption key={`valami-${index}`} value={index}>
                                {`${capitalizeFirstLetter(a.taxpayerAddress.postalCode)} ${capitalizeFirstLetter(a.taxpayerAddress.city)} ${capitalizeFirstLetter(a.taxpayerAddress.streetName)} ${capitalizeFirstLetter(
                                  a.taxpayerAddress.publicPlaceCategory
                                )} ${capitalizeFirstLetter(a.taxpayerAddress.number ?? "")}`}
                              </IonSelectOption>
                            ))}
                          </IonSelect>
                        </div>
                      </IonCol>
                    </IonRow>
                  ) : null}

                  <IonRow>
                    <IonCol size="12" sizeSm="1">
                      <InputWrapper
                        name="Postal_ZipCode"
                        label="IRSZ"
                        controlData={{
                          control: control,
                          rules: {},
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                        }}
                        error={errors.Postal_ZipCode}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="3">
                      <InputWrapper
                        name="Postal_City"
                        label="Település"
                        controlData={{
                          control: control,
                          rules: {},
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                        }}
                        error={errors.Postal_City}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="4">
                      <InputWrapper
                        name="Postal_Street"
                        label="Közterület neve"
                        controlData={{
                          control: control,
                          rules: {},
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                        }}
                        error={errors.Postal_Street}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="2">
                      <SelectWrapper
                        name="Postal_State"
                        label="Közterület jellege"
                        controlData={{
                          control: control,
                          rules: {},
                        }}
                        selectData={{}}
                        options={kozterulet_tipusok.map((kozterulet_tipus: any) => ({
                          key: kozterulet_tipus.id,
                          name: kozterulet_tipus.label,
                        }))}
                        error={errors.Postal_State}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="2">
                      <InputWrapper
                        name="Postal_StreetNo"
                        label="Házszám"
                        controlData={{
                          control: control,
                          rules: {},
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                        }}
                        error={errors.Postal_StreetNo}
                      />
                    </IonCol>
                  </IonRow>
                </IonGrid>

                <IonGrid className="has-bg" fixed>
                  <IonRow>
                    <IonCol>
                      <h4
                        style={{
                          color: "var(--ion-color-primary)",
                        }}
                      >
                        <b>Egyéb adatok</b>
                      </h4>
                    </IonCol>
                  </IonRow>

                  <IonRow>
                    <IonCol size="12" sizeSm="4">
                      <PhoneWrapper
                        name="Phone1"
                        label="Szerződő telefonszáma"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        error={errors.Phone1}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="4">
                      <SelectWrapper
                        name="U_ObjJelleg"
                        label="Ingatlan jellege"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        selectData={{}}
                        options={[
                          {
                            key: "CSALADIHAZ",
                            name: "Családi ház",
                          },
                          {
                            key: "CSARNOK",
                            name: "Csarnok",
                          },
                          {
                            key: "EGYEB",
                            name: "Egyéb, ismeretlen",
                          },
                          {
                            key: "GARAZS",
                            name: "Garázs",
                          },
                          {
                            key: "IKERHAZ",
                            name: "Ikerház",
                          },
                          {
                            key: "IRODA",
                            name: "Iroda",
                          },
                          {
                            key: "KOZINTEZMENY",
                            name: "Közintézmény",
                          },
                          {
                            key: "LAKAS",
                            name: "Lakás",
                          },
                          {
                            key: "NAPELEMPARK",
                            name: "Napelempark",
                          },
                          {
                            key: "NYARALO",
                            name: "Nyaraló",
                          },
                          {
                            key: "PENZFORGALMI",
                            name: "Pénzforgalmi",
                          },
                          {
                            key: "RAKTAR",
                            name: "Raktár",
                          },
                          {
                            key: "SORHAZ",
                            name: "Sorház",
                          },
                          {
                            key: "TELEPHELY",
                            name: "Telephely",
                          },
                          {
                            key: "TRAFIK",
                            name: "Trafik",
                          },
                          {
                            key: "UZLET",
                            name: "Üzlet",
                          },
                        ]}
                        error={errors.U_ObjJelleg}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="4">
                      <SelectWrapper
                        name="U_PartnerJogcim"
                        label="Szerződő jogcíme"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        selectData={{}}
                        options={[
                          {
                            key: "TUL",
                            name: "Tulajdonos",
                          },
                          {
                            key: "BER",
                            name: "Bérlő",
                          },
                          {
                            key: "EGL",
                            name: "Együttlakó",
                          },
                          {
                            key: "EGY",
                            name: "Egyéb",
                          },
                        ]}
                        error={errors.U_PartnerJogcim}
                      />
                    </IonCol>
                  </IonRow>

                  {watch("U_PartnerJogcim") === "BER" ? (
                    <IonRow>
                      <IonCol size="12" sizeSm="4">
                        <InputWrapper
                          name="U_TulNeve"
                          label="Tulajdonos neve"
                          controlData={{
                            control: control,
                            rules: {
                              required: {
                                value: true,
                                message: "Kötelező mező",
                              },
                            },
                          }}
                          inputData={{
                            placeholder: "Tulajdonos neve",
                            type: "text",
                            pattern: "text",
                          }}
                          error={errors.U_TulNeve}
                        />
                      </IonCol>
                      <IonCol size="12" sizeSm="4">
                        <PhoneWrapper
                          name="U_TulTelefon"
                          label="Tulajdonos telefonszáma"
                          controlData={{
                            control: control,
                            rules: {
                              required: {
                                value: true,
                                message: "Kötelező mező",
                              },
                            },
                          }}
                          error={errors.U_TulTelefon}
                        />
                      </IonCol>
                    </IonRow>
                  ) : null}

                  <IonRow>
                    <IonCol size="12" sizeSm="4">
                      <SelectWrapper
                        name="U_SzamlaTipus"
                        label="Számla típusa"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        selectData={{}}
                        options={[
                          {
                            key: "T",
                            name: "Távszámla",
                          },
                          {
                            key: "P",
                            name: "Papír alapú",
                          },
                        ]}
                        error={errors.U_SzamlaTipus}
                      />
                    </IonCol>
                    {watch("U_SzamlaTipus") === "T" ? (
                      <IonCol size="12" sizeSm="4">
                        <InputWrapper
                          name="E_Mail"
                          label="Távszámla email cím"
                          controlData={{
                            control: control,
                            rules: {
                              required: {
                                value: true,
                                message: "Kötelező mező",
                              },
                              pattern: {
                                value: /\S+@\S+\.\S+/,
                                message: "Hibás email cím formátum",
                              },
                            },
                          }}
                          inputData={{
                            type: "text",
                            pattern: "text",
                          }}
                          error={errors.E_Mail}
                        />
                      </IonCol>
                    ) : null}

                    <IonCol size="12" sizeSm="4">
                      {/* TODO: Ha TÁVSZÁMLÁT választott az ÜP, akkor nem lehet CSEKKES-t választani  */}
                      <SelectWrapper
                        name="GroupNum"
                        label="Fizetési mód"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        selectData={{}}
                        options={
                          watch("U_SzamlaTipus") == "T"
                            ? [
                                {
                                  key: "2",
                                  name: "Csoportos beszedés",
                                },
                                {
                                  key: "8",
                                  name: "Átutalás",
                                },
                              ]
                            : [
                                // { key: "-1", name: "Készpénz" },
                                // { key: "1", name: "Átutalás 8 nap" },
                                {
                                  key: "2",
                                  name: "Csoportos beszedés",
                                },
                                {
                                  key: "3",
                                  name: "Csekkes",
                                },
                                // { key: "4", name: "Átutalás 45 nap" },
                                // { key: "5", name: "Átutalás 20 nap" },
                                // { key: "6", name: "Átutalás 60 nap" },
                                // { key: "7", name: "Átutalás 30 nap" },
                                {
                                  key: "8",
                                  name: "Átutalás",
                                },
                                // { key: "9", name: "Átutalás 15 nap" },
                              ]
                        }
                        error={errors.GroupNum}
                      />
                    </IonCol>
                  </IonRow>

                  <IonRow>
                    <IonCol size="12" sizeSm="4">
                      <SelectWrapper
                        name="U_Kutya"
                        label="Kisállat az ingatlanban vagy az udvaron"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        selectData={{}}
                        options={[
                          { key: "Y", name: "Van" },
                          { key: "N", name: "Nincs" },
                        ]}
                        error={errors.U_Kutya}
                      />
                    </IonCol>
                    <IonCol size="12" sizeSm="4">
                      <InputWrapper
                        name="U_LemondoJelszo"
                        label="Lemondó (azonosító) jelszó"
                        controlData={{
                          control: control,
                          rules: {
                            required: {
                              value: true,
                              message: "Kötelező mező",
                            },
                          },
                        }}
                        inputData={{
                          type: "text",
                          pattern: "text",
                        }}
                        error={errors.U_LemondoJelszo}
                      />
                    </IonCol>
                  </IonRow>

                  {!ceges ? (
                    <>
                      <IonRow>
                        <IonCol size="12" sizeSm="4">
                          <InputWrapper
                            name="U_AnyjaNeve"
                            label="Anyja neve"
                            controlData={{
                              control: control,
                              rules: {
                                required: {
                                  value: true,
                                  message: "Kötelező mező",
                                },
                              },
                            }}
                            inputData={{
                              type: "text",
                              pattern: "text",
                            }}
                            error={errors.U_AnyjaNeve}
                          />
                        </IonCol>
                        <IonCol size="12" sizeSm="4">
                          <InputWrapper
                            name="U_SzulHely"
                            label="Születési hely"
                            controlData={{
                              control: control,
                              rules: {
                                required: {
                                  value: true,
                                  message: "Kötelező mező",
                                },
                              },
                            }}
                            inputData={{
                              type: "text",
                              pattern: "text",
                            }}
                            error={errors.U_SzulHely}
                          />
                        </IonCol>
                        <IonCol size="12" sizeSm="4">
                          <InputWrapper
                            name="U_SzulIdo"
                            label="Születési idő"
                            controlData={{
                              control: control,
                              rules: {
                                required: {
                                  value: true,
                                  message: "Kötelező mező",
                                },
                              },
                            }}
                            inputData={{
                              type: "date",
                              pattern: "date",
                            }}
                            error={errors.U_SzulIdo}
                          />
                        </IonCol>
                      </IonRow>
                    </>
                  ) : null}
                </IonGrid>

                <IonGrid className="has-bg" fixed>
                  <IonRow>
                    <IonCol>
                      <h4>
                        <b
                          style={{
                            color: "var(--ion-color-primary)",
                          }}
                        >
                          Értesítendők
                        </b>
                      </h4>
                    </IonCol>
                  </IonRow>

                  {[...Array(ertesitendokCount)].map((x, i) => (
                    <React.Fragment key={`ertesitendok-${i}`}>
                      <IonRow>
                        <IonCol>
                          <IonText
                            color="dark"
                            style={{
                              margin: "0 0 10px",
                              display: "block",
                            }}
                          >
                            <b>{i + 1}. értesítendő</b>
                          </IonText>
                        </IonCol>
                      </IonRow>
                      <IonRow className="ertesitendo-row" style={{ marginBottom: 15 }}>
                        <IonCol size="12" sizeSm="3">
                          <InputWrapper
                            name={`Ertesitendok-${i}-U_Name`}
                            label="Név"
                            controlData={{
                              control: control,
                              rules: {
                                required: {
                                  value: true,
                                  message: "Kötelező mező",
                                },
                              },
                            }}
                            inputData={{
                              type: "text",
                              pattern: "text",
                            }}
                            // @ts-ignore
                            error={(errors as any)[`Ertesitendok-${i}-U_Name`]}
                          />
                        </IonCol>
                        <IonCol size="12" sizeSm="3">
                          <PhoneWrapper
                            name={`Ertesitendok-${i}-U_Telefon`}
                            label="Telefonszám"
                            controlData={{
                              control: control,
                              rules: {
                                required: {
                                  value: true,
                                  message: "Kötelező mező",
                                },
                              },
                            }}
                            // @ts-ignore
                            error={(errors as any)[`Ertesitendok-${i}-U_Telefon`]}
                          />
                        </IonCol>
                        <IonCol size="12" sizeSm="3">
                          <InputWrapper
                            name={`Ertesitendok-${i}-U_E_mail`}
                            label="Email cím"
                            controlData={{
                              control: control,
                              rules: {
                                pattern: {
                                  value: /\S+@\S+\.\S+/,
                                  message: "Hibás email cím formátum",
                                },
                              },
                            }}
                            inputData={{
                              type: "text",
                              pattern: "text",
                            }}
                            // @ts-ignore
                            error={(errors as any)[`Ertesitendok-${i}-U_E_mail`]}
                          />
                        </IonCol>
                        <IonCol size="12" sizeSm="3" style={{ paddingTop: 30 }}>
                          <IonRadioGroup value={selectedTechnikaiSmsIndex} onIonChange={(e) => setSelectedTechnikaiSmsIndex(e.detail.value)}>
                            <IonItem className="ion-item-radio">
                              <IonLabel>Technikai SMS</IonLabel>
                              <IonRadio mode="md" name={`Ertesitendok-${i}-U_TechnikaiSMS`} value={i} slot="start" />
                            </IonItem>
                            {(errors as any)[`Ertesitendok-${i}-U_TechnikaiSMS`] ? <InputError>{(errors as any)[`Ertesitendok-${i}-U_TechnikaiSMS`].message ?? ""}</InputError> : null}
                          </IonRadioGroup>
                        </IonCol>
                      </IonRow>
                    </React.Fragment>
                  ))}

                  <IonRow>
                    <IonCol size="12" sizeSm="3">
                      <IonButton
                        expand="block"
                        fill="outline"
                        onClick={() => {
                          setErtesitendokCount((prevState) => ++prevState);
                        }}
                      >
                        <IonIcon slot="start" icon={add} />
                        Értesítendő hozzáadása
                      </IonButton>
                    </IonCol>
                    {ertesitendokCount > 1 ? (
                      <IonCol size="12" sizeSm="3">
                        <IonButton
                          expand="block"
                          fill="outline"
                          color="danger"
                          onClick={() => {
                            setErtesitendokCount((prevState) => --prevState);
                          }}
                          style={{ marginBottom: 10 }}
                        >
                          <IonIcon slot="start" icon={trashOutline} />
                          Értesítendő törlése
                        </IonButton>
                      </IonCol>
                    ) : null}
                  </IonRow>
                </IonGrid>

                <IonGrid className="has-bg" fixed>
                  <div>
                    <CheckboxWrapper
                      name="U_myPatentAktivalas"
                      controlData={{
                        control: control,
                      }}
                      label={
                        "A Távfelügyeleti szolgáltatás „Aktiválása” az ingyenesen letölthető és ingyenesen használható, myPatent ügyfélszolgálati applikáción, vagy webes ügyfélkapun keresztül lehetséges. Letöltésében és az aktiválás folyamatában kollégáink segítséget nyújtanak!"
                      }
                      error={errors.U_myPatentAktivalas}
                    />
                  </div>

                  <div>
                    <CheckboxWrapper
                      name="U_Adatkezeles"
                      controlData={{
                        control: control,
                      }}
                      label={"Az Adatvédelmi nyilatkozatot elfogadom"}
                      error={errors.U_Adatkezeles}
                    />
                    <InputHint>
                      <a href="https://securitypatent.hu/mypatent-adatvedelmi-tajekoztato/" target="_blank">
                        Adatkezelési nyilatkozat megtekintése
                      </a>
                    </InputHint>
                  </div>

                  <div className="ion-margin-top">
                    <IonButton onClick={() => handleSubmit()} color="success" expand="block">
                      Mentés és beküldés
                    </IonButton>
                  </div>
                </IonGrid>
              </>
            )}
          </>
        )}
      </IonContent>

      {/*
      <IonAlert
        isOpen={selectableAddresses.length > 0}
        onDidDismiss={() => {
          setSelectableAddresses([]);
        }}
        header="Válasszon címet"
        inputs={selectableAddresses.map((a: any, index: number) => ({
          name: `radio-address-${index}`,
          type: "radio",
          label: `${capitalizeFirstLetter(a.taxpayerAddress.postalCode)} ${capitalizeFirstLetter(a.taxpayerAddress.city)} ${capitalizeFirstLetter(a.taxpayerAddress.streetName)} ${capitalizeFirstLetter(
            a.taxpayerAddress.publicPlaceCategory
          )} ${capitalizeFirstLetter(a.taxpayerAddress.number ?? "")}`,
          value: index,
        }))}
        buttons={[
          {
            text: "Mégse",
            role: "cancel",
          },
          {
            text: "Kiválasztás",
            handler: (value) => {
              if (value) {
                const a = selectableAddresses[value];
                setValue("Billing_City", capitalizeFirstLetter(a.taxpayerAddress.city.to));
                setValue("Billing_Street", capitalizeFirstLetter(a.taxpayerAddress.streetName));
                setValue("Billing_StreetNo", capitalizeFirstLetter(a.taxpayerAddress.number ?? ""));
                setValue("Billing_ZipCode", capitalizeFirstLetter(a.taxpayerAddress.postalCode));
                setValue("Billing_State", capitalizeFirstLetter(a.taxpayerAddress.publicPlaceCategory));
              }
            },
          },
        ]}
      />
      */}
    </IonPage>
  );
};

export default ElectronicDataRequestPage;

const kozterulet_tipusok: any = [
  {
    id: "23",
    label: "akna",
  },
  {
    id: "24",
    label: "akna - alsó",
  },
  {
    id: "07",
    label: "árok",
  },
  {
    id: "25",
    label: "csomópont",
  },
  {
    id: "06",
    label: "domb",
  },
  {
    id: "09",
    label: "dűlő",
  },
  {
    id: "16",
    label: "épület",
  },
  {
    id: "20",
    label: "fasor",
  },
  {
    id: "26",
    label: "ház",
  },
  {
    id: "27",
    label: "hegy",
  },
  {
    id: "17",
    label: "HRSZ",
  },
  {
    id: "28",
    label: "kapu",
  },
  {
    id: "29",
    label: "kerület",
  },
  {
    id: "22",
    label: "körtér",
  },
  {
    id: "10",
    label: "körút",
  },
  {
    id: "14",
    label: "köz",
  },
  {
    id: "30",
    label: "külterület",
  },
  {
    id: "31",
    label: "lakópark",
  },
  {
    id: "12",
    label: "lakótelep",
  },
  {
    id: "08",
    label: "liget",
  },
  {
    id: "15",
    label: "major",
  },
  {
    id: "32",
    label: "mélyút",
  },
  {
    id: "33",
    label: "Pályaudvar",
  },
  {
    id: "34",
    label: "park",
  },
  {
    id: "35",
    label: "part",
  },
  {
    id: "36",
    label: "Postafiók",
  },
  {
    id: "37",
    label: "puszta",
  },
  {
    id: "13",
    label: "rakpart",
  },
  {
    id: "18",
    label: "sétány",
  },
  {
    id: "02",
    label: "sor",
  },
  {
    id: "21",
    label: "sugárút",
  },
  {
    id: "46",
    label: "szer",
  },
  {
    id: "38",
    label: "sziget",
  },
  {
    id: "39",
    label: "tanya",
  },
  {
    id: "40",
    label: "tár",
  },
  {
    id: "11",
    label: "telep",
  },
  {
    id: "05",
    label: "tér",
  },
  {
    id: "19",
    label: "tere",
  },
  {
    id: "41",
    label: "udvar",
  },
  {
    id: "03",
    label: "út",
  },
  {
    id: "42",
    label: "utak",
  },
  {
    id: "01",
    label: "utca",
  },
  {
    id: "43",
    label: "utcája",
  },
  {
    id: "44",
    label: "útja",
  },
  {
    id: "04",
    label: "útja",
  },
  {
    id: "45",
    label: "zug",
  },
];
